import * as qs from 'qs';
import {clearBatteryTypes} from '../store/actions/options';
import {API} from './API';

export class BatteryTypeService {
  async getTableTypes(params, additional = {}) {
    const [query, page, length] = API.getTableParams(params, additional);
    return this.getTypes(query, page, length);
  }

  async getTypes(query, page, length) {
    return (await API.getConnection())
      .get('battery-types', {
        params: {...query, ...{page, length}},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data)
      .catch(error => API.handleError(error));
  }

  async saveType(data) {
    let method = 'post';
    let url = 'battery-types';
    if (data.id) {
      method = 'put';
      url = `${url}/${data.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => {
        API.store.dispatch(clearBatteryTypes());
        return response.data.data
      })
      .catch(error => API.handleError(error));
  }
}
